import React, {Component} from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import {
    Card, CardBody, Button, ButtonGroup, FormGroup, Label, Col, Row, Input, Badge
} from 'reactstrap';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {API_ROOT} from '../../api-config';
import Swal from 'sweetalert2'
import {getInvLists} from './InventoryFunctions.js';
import {getProducts} from '../Products/ProductFunctions.js';

const TABS = [
    {key: 'items', name: 'Items'},
    {key: 'suppliers', name: 'Suppliers'},
    {key: 'locations', name: 'Locations'},
    {key: 'boms', name: 'Bills of Materials'},
    {key: 'accounts', name: 'Adjustment Accounts'},
];

const fmt = (v) => {
    const n = parseFloat(v) || 0;
    return (Math.round(n * 100) / 100).toLocaleString('en-CA', {maximumFractionDigits: 2});
};

class InventoryLists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: 'items',
            lists: {items: [], locations: [], suppliers: [], accounts: [], boms: [], item_types: []},
            products: {},
            // new-record forms
            newItem: {code: '', type: '', uom: 'Each', moq: '', lead_days: '', default_location_id: '', supplier_id: '', product_id: '', description: ''},
            newSupplier: {name: '', address: '', city: ''},
            newLocation: {name: '', can_deliver: false},
            newBom: {code: '', item_id: '', output_qty: 1, lines: [{item_id: '', qty_per: ''}]},
            processing: false
        };
    }

    componentDidMount() {
        document.title = "Inventory Lists | Jug Beverage Company";
        this.reload();
    }

    reload = () => {
        var self = this;
        getInvLists(function (lists) {
            self.setState({lists: lists});
        });
        getProducts(function (products) {
            self.setState({products: products});
        });
    }

    post = (path, data, label) => {
        var self = this;
        this.setState({processing: true});
        axios.defaults.withCredentials = true;
        axios.post(API_ROOT + path, data, {withCredentials: true})
            .then(function (resp) {
                Swal("Saved", label + " saved.", "success");
                self.setState({processing: false}, () => self.reload());
            })
            .catch(function (error) {
                Swal("Error", error.response && error.response.data ? error.response.data.Message : 'Save failed', "error");
                self.setState({processing: false});
            });
    }

    putItem = (item_id, field, value) => {
        var self = this;
        var data = {};
        data[field] = value;
        axios.defaults.withCredentials = true;
        axios.put(API_ROOT + '/inventory/item/' + item_id, data, {withCredentials: true})
            .then(function () {
                self.reload();
            })
            .catch(function (error) {
                Swal("Error", error.response && error.response.data ? error.response.data.Message : 'Save failed', "error");
            });
    }

    setNew = (key, k, v) => {
        var st = {};
        st[key] = this.state[key];
        st[key][k] = v;
        this.setState(st);
    }

    setBomLine = (i, k, v) => {
        var nb = this.state.newBom;
        nb.lines[i][k] = v;
        this.setState({newBom: nb});
    }

    locName(id) {
        var l = this.state.lists.locations.find(x => x.inventory_source_id == id);
        return l ? l.name : '—';
    }

    supName(id) {
        var s = this.state.lists.suppliers.find(x => x.supplier_id == id);
        return s ? s.name : '—';
    }

    renderItems() {
        var self = this;
        var ni = this.state.newItem;
        var products = this.state.products;
        var stockItems = this.state.lists.items.filter(i => ['Copack', 'Repack'].indexOf(i.type) === -1);
        return (
            <div>
                <Card className="card-default mb-3">
                    <div className="card-header"><div className="card-title">Add Item</div></div>
                    <CardBody>
                        <div className="form-inline mb-2">
                            <Input className="mr-1 mb-1" placeholder="Item code *" style={{width: '240px'}} value={ni.code}
                                   onChange={(e) => self.setNew('newItem', 'code', e.target.value)}/>
                            <Input type="select" className="mr-1 mb-1" style={{width: '150px'}} value={ni.type}
                                   onChange={(e) => self.setNew('newItem', 'type', e.target.value)}>
                                <option value="">Type *</option>
                                {this.state.lists.item_types.map(t => <option key={t} value={t}>{t}</option>)}
                            </Input>
                            <Input className="mr-1 mb-1" placeholder="UOM" style={{width: '90px'}} value={ni.uom}
                                   onChange={(e) => self.setNew('newItem', 'uom', e.target.value)}/>
                            <Input className="mr-1 mb-1" placeholder="MOQ" type="number" style={{width: '90px'}} value={ni.moq}
                                   onChange={(e) => self.setNew('newItem', 'moq', e.target.value)}/>
                            <Input className="mr-1 mb-1" placeholder="Lead days" type="number" style={{width: '100px'}} value={ni.lead_days}
                                   onChange={(e) => self.setNew('newItem', 'lead_days', e.target.value)}/>
                        </div>
                        <div className="form-inline mb-2">
                            <Input type="select" className="mr-1 mb-1" style={{width: '190px'}} value={ni.default_location_id}
                                   onChange={(e) => self.setNew('newItem', 'default_location_id', e.target.value)}>
                                <option value="">Default location</option>
                                {this.state.lists.locations.filter(l => l.is_transit != 1).map(l =>
                                    <option key={l.inventory_source_id} value={l.inventory_source_id}>{l.name}</option>)}
                            </Input>
                            <Input type="select" className="mr-1 mb-1" style={{width: '190px'}} value={ni.supplier_id}
                                   onChange={(e) => self.setNew('newItem', 'supplier_id', e.target.value)}>
                                <option value="">Supplier</option>
                                {this.state.lists.suppliers.map(s =>
                                    <option key={s.supplier_id} value={s.supplier_id}>{s.name}</option>)}
                            </Input>
                            <Input type="select" className="mr-1 mb-1" style={{width: '220px'}} value={ni.product_id}
                                   onChange={(e) => self.setNew('newItem', 'product_id', e.target.value)}>
                                <option value="">Link to product (finished goods)</option>
                                {Object.keys(products).map(pid =>
                                    <option key={pid} value={pid}>{products[pid].name}</option>)}
                            </Input>
                            <Input className="mr-1 mb-1" placeholder="Description" style={{width: '200px'}} value={ni.description}
                                   onChange={(e) => self.setNew('newItem', 'description', e.target.value)}/>
                            <Button color="primary" size="sm" disabled={this.state.processing}
                                    onClick={() => self.post('/inventory/item', ni, 'Item')}>Add Item</Button>
                        </div>
                        <p className="small text-muted mb-0">
                            Link a product so orders and BOLs decrement this item's stock. Copack / Repack items are service charges — they hold no stock.
                        </p>
                    </CardBody>
                </Card>
                <div className="table-responsive">
                    <table className="table table-hover table-sm">
                        <thead>
                        <tr>
                            <th>Code</th><th>Type</th><th>UOM</th>
                            <th className="text-right">MOQ</th><th className="text-right">Lead (days)</th>
                            <th>Default location</th><th>Supplier</th><th>Product link</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.lists.items.map(function (i, k) {
                            var svc = ['Copack', 'Repack'].indexOf(i.type) !== -1;
                            return (
                                <tr key={k}>
                                    <td><b>{i.code}</b>{i.description ? <div className="small text-muted">{i.description}</div> : null}</td>
                                    <td>{i.type}{svc ? <Badge color="info" className="ml-1">service</Badge> : null}</td>
                                    <td>{i.uom}</td>
                                    <td className="text-right">{i.moq != null ? fmt(i.moq) : '—'}</td>
                                    <td className="text-right">{i.lead_days != null ? i.lead_days : '—'}</td>
                                    <td>
                                        <Input type="select" bsSize="sm" value={i.default_location_id || ''}
                                               onChange={(e) => self.putItem(i.item_id, 'default_location_id', e.target.value || null)}>
                                            <option value="">—</option>
                                            {self.state.lists.locations.filter(l => l.is_transit != 1).map(l =>
                                                <option key={l.inventory_source_id} value={l.inventory_source_id}>{l.name}</option>)}
                                        </Input>
                                    </td>
                                    <td>
                                        <Input type="select" bsSize="sm" value={i.supplier_id || ''}
                                               onChange={(e) => self.putItem(i.item_id, 'supplier_id', e.target.value || null)}>
                                            <option value="">—</option>
                                            {self.state.lists.suppliers.map(s =>
                                                <option key={s.supplier_id} value={s.supplier_id}>{s.name}</option>)}
                                        </Input>
                                    </td>
                                    <td>
                                        <Input type="select" bsSize="sm" value={i.product_id || ''}
                                               onChange={(e) => self.putItem(i.item_id, 'product_id', e.target.value || null)}>
                                            <option value="">—</option>
                                            {Object.keys(products).map(pid =>
                                                <option key={pid} value={pid}>{products[pid].name}</option>)}
                                        </Input>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderSuppliers() {
        var self = this;
        var ns = this.state.newSupplier;
        return (
            <div>
                <Card className="card-default mb-3">
                    <div className="card-header"><div className="card-title">Add Supplier / Carrier</div></div>
                    <CardBody>
                        <div className="form-inline">
                            <Input className="mr-1 mb-1" placeholder="Name *" style={{width: '220px'}} value={ns.name}
                                   onChange={(e) => self.setNew('newSupplier', 'name', e.target.value)}/>
                            <Input className="mr-1 mb-1" placeholder="Address" style={{width: '220px'}} value={ns.address}
                                   onChange={(e) => self.setNew('newSupplier', 'address', e.target.value)}/>
                            <Input className="mr-1 mb-1" placeholder="City" style={{width: '220px'}} value={ns.city}
                                   onChange={(e) => self.setNew('newSupplier', 'city', e.target.value)}/>
                            <Button color="primary" size="sm" disabled={this.state.processing}
                                    onClick={() => self.post('/inventory/supplier', ns, 'Supplier')}>Add Supplier</Button>
                        </div>
                    </CardBody>
                </Card>
                <div className="table-responsive">
                    <table className="table table-hover table-sm">
                        <thead><tr><th>Name</th><th>Address</th><th>City</th></tr></thead>
                        <tbody>
                        {this.state.lists.suppliers.map((s, i) =>
                            <tr key={i}><td><b>{s.name}</b></td><td>{s.address || '—'}</td><td>{s.city || '—'}</td></tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderLocations() {
        var self = this;
        var nl = this.state.newLocation;
        return (
            <div>
                <Card className="card-default mb-3">
                    <div className="card-header"><div className="card-title">Add Location</div></div>
                    <CardBody>
                        <div className="form-inline">
                            <Input className="mr-1 mb-1" placeholder="Name *" style={{width: '220px'}} value={nl.name}
                                   onChange={(e) => self.setNew('newLocation', 'name', e.target.value)}/>
                            <Label check className="mr-2 mb-1">
                                <Input type="checkbox" checked={nl.can_deliver}
                                       onChange={(e) => self.setNew('newLocation', 'can_deliver', e.target.checked)}/>
                                &nbsp;Can deliver to customers
                            </Label>
                            <Button color="primary" size="sm" disabled={this.state.processing}
                                    onClick={() => self.post('/inventory/location', nl, 'Location')}>Add Location</Button>
                        </div>
                        <p className="small text-muted mb-0">Locations are shared with orders and deliveries ("inventory sources"). IN TRANSIT is managed by the system.</p>
                    </CardBody>
                </Card>
                <div className="table-responsive">
                    <table className="table table-hover table-sm">
                        <thead><tr><th>Name</th><th>Can deliver</th><th>Notes</th></tr></thead>
                        <tbody>
                        {this.state.lists.locations.map((l, i) =>
                            <tr key={i}>
                                <td><b>{l.name}</b></td>
                                <td>{l.can_deliver == 1 ? 'Yes' : 'No'}</td>
                                <td>{l.is_transit == 1 ? <Badge color="info">system — goods in transit</Badge> : ''}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderBoms() {
        var self = this;
        var nb = this.state.newBom;
        var items = this.state.lists.items;
        var fgItems = items.filter(i => i.type === 'Finished Good' || i.type === 'WIP');
        return (
            <div>
                <Card className="card-default mb-3">
                    <div className="card-header"><div className="card-title">Add Bill of Materials</div></div>
                    <CardBody>
                        <div className="form-inline mb-2">
                            <Input className="mr-1 mb-1" placeholder="BOM code *" style={{width: '200px'}} value={nb.code}
                                   onChange={(e) => self.setNew('newBom', 'code', e.target.value)}/>
                            <Input type="select" className="mr-1 mb-1" style={{width: '240px'}} value={nb.item_id}
                                   onChange={(e) => self.setNew('newBom', 'item_id', e.target.value)}>
                                <option value="">Output item *</option>
                                {fgItems.map(i => <option key={i.item_id} value={i.item_id}>{i.code}</option>)}
                            </Input>
                            <Input className="mr-1 mb-1" placeholder="Output qty" type="number" style={{width: '110px'}} value={nb.output_qty}
                                   onChange={(e) => self.setNew('newBom', 'output_qty', e.target.value)}/>
                        </div>
                        {nb.lines.map((l, i) =>
                            <div className="form-inline mb-1" key={i}>
                                <Input type="select" className="mr-1 mb-1" style={{width: '300px'}} value={l.item_id}
                                       onChange={(e) => self.setBomLine(i, 'item_id', e.target.value)}>
                                    <option value="">Component / service</option>
                                    {items.map(x => <option key={x.item_id} value={x.item_id}>{x.code} ({x.type})</option>)}
                                </Input>
                                <Input className="mr-1 mb-1" placeholder="Qty per" type="number" step="0.0001" style={{width: '110px'}} value={l.qty_per}
                                       onChange={(e) => self.setBomLine(i, 'qty_per', e.target.value)}/>
                            </div>)}
                        <Button size="sm" color="default" className="mr-2" onClick={() => {
                            nb.lines.push({item_id: '', qty_per: ''});
                            self.setState({newBom: nb});
                        }}>+ Line</Button>
                        <Button color="primary" size="sm" disabled={this.state.processing}
                                onClick={() => self.post('/inventory/bom', nb, 'Bill of materials')}>Add BOM</Button>
                    </CardBody>
                </Card>
                <div className="table-responsive">
                    <table className="table table-hover table-sm">
                        <thead><tr><th>Code</th><th>Makes</th><th>Components</th></tr></thead>
                        <tbody>
                        {this.state.lists.boms.map((b, i) =>
                            <tr key={i}>
                                <td><b>{b.code}</b></td>
                                <td>{b.item_code} × {fmt(b.output_qty)}</td>
                                <td className="small">{b.lines.map(l => l.item_code + ' × ' + fmt(l.qty_per)).join(', ')}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderAccounts() {
        return (
            <div>
                <div className="table-responsive">
                    <table className="table table-hover table-sm">
                        <thead><tr><th>Account</th><th>Type</th></tr></thead>
                        <tbody>
                        {this.state.lists.accounts.map((a, i) =>
                            <tr key={i}>
                                <td><b>{a.name}</b></td>
                                <td>{a.is_count == 1 ? <Badge color="info">stock count — no financial impact</Badge> : 'financial adjustment'}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <p className="small text-muted">Adjustment accounts are maintained in the database (<code>inv_accounts</code>) — add rows there to extend this list.</p>
            </div>
        );
    }

    render() {
        var self = this;
        var tab = this.state.tab;
        return (
            <ContentWrapper>
                <div className="content-heading">
                    <Link to="../inventory">Inventory</Link>&nbsp;/&nbsp;Lists
                </div>
                <div className="text-center mb-3">
                    <ButtonGroup>
                        {TABS.map(t =>
                            <Button key={t.key} size="sm" color={(tab === t.key ? "info" : "secondary")}
                                    onClick={() => this.setState({tab: t.key})}>{t.name}</Button>)}
                    </ButtonGroup>
                </div>
                <Card className="card-default">
                    <CardBody>
                        {tab === 'items' ? this.renderItems() : null}
                        {tab === 'suppliers' ? this.renderSuppliers() : null}
                        {tab === 'locations' ? this.renderLocations() : null}
                        {tab === 'boms' ? this.renderBoms() : null}
                        {tab === 'accounts' ? this.renderAccounts() : null}
                    </CardBody>
                </Card>
            </ContentWrapper>
        );
    }
}

export default InventoryLists;
